import { defineMessages } from 'react-intl';

export const ratesPanelMessages = defineMessages({
  title: {
    defaultMessage: 'Rates',
    id: 'InzZWH',
    description: 'Title for the rates panel',
  },
  carriersAvailable: {
    defaultMessage: '{count, plural, one {# carrier available} other {# carriers available}}',
    id: '+pA7v8',
    description: 'Subtitle showing carrier availability',
  },
  noRates: {
    defaultMessage: 'No rates available. Fill out the form and click Browse Rates.',
    id: '5xc0bT',
    description: 'Empty state message when no rates are loaded',
  },
  standardLabel: {
    defaultMessage: 'Standard',
    id: 'iltT3H',
    description: 'Label for standard shipping option',
  },
  guaranteedLabel: {
    defaultMessage: 'Guaranteed',
    id: 'irmtVg',
    description: 'Label for guaranteed shipping option',
  },
  transitDays: {
    defaultMessage: '{days, plural, one {# day} other {# days}}',
    id: 'S4Olss',
    description: 'Transit time in days',
  },
  viewDetails: {
    defaultMessage: 'View Details',
    id: 'NKRtjH',
    description: 'Link to view rate details',
  },
});
